import drowDown from './drowDown.vue'
import mOption from './option.vue'
const drowDowns = {
    install: function(Vue) {
        // 注册并获取组件，然后在main.js中引用，在Vue.use()就可以了
        Vue.component('drowDowns', drowDown)
        Vue.component('options', mOption)
    }
}
export default drowDowns


// WEBPACK FOOTER //
// ./src/components/form/drowDown/index.js